import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与
import { useTranslation } from 'react-i18next';
import { CloseButton } from '../closeButtonComponent';

type Props = {
  hiddenSaveBackupCardStatus:string,
  qrTagStatus:any,
  // backupcardAddress:string,
  // languageExchange:any,
}
export const HiddenSaveBackupCard: React.FC<Props> = (props) => {
  const [backupCardAddressStatus,setBackupCardAddressStatus] = React.useState(``);
  const [t, i18n] = useTranslation();
  const HiddenSaveBackupCardButtonDiv = styled.div`
    justify-content: center;
    display: flex;
  `;
  const HiddenSaveBackupCardDiv = styled.div`
    margin-top: 80px;
    margin-bottom: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px;
    gap: 12px;
    width: 320px;
    height: 583.44px;
    background: linear-gradient(339.68deg, rgba(239, 239, 239, 0.6) 4.62%, rgba(255, 255, 255, 0.45) 93.97%);
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    flex: none;
    order: 1;
    flex-grow: 0;
    display: ${props.hiddenSaveBackupCardStatus};
  `;
  const BackupCardTitleComponent = styled.p`
    font-weight: bold;
    color:black;
  `;
  const BackupCardImageComponent = styled.img`
    height: 40px;
    align-items: center;
  `;
  const QRcodeComponent = styled.div`
    width:256px;
    margin:0 auto;
  `;
  const BackupcardAddressText = styled.p`
    color:black;
  `;
  const BackupcardMessageText = styled.p`
    color:black;
  `;
  React.useEffect(()=>{
    if (localStorage.getItem('walletAddressFromPK')) {
      setBackupCardAddressStatus(`address:${localStorage.getItem('walletAddressFromPK').substring(0,20)}...`);
    } else {
      setBackupCardAddressStatus(`None Address`);
    }
  },[]);
  return (
    <HiddenSaveBackupCardButtonDiv id="savebackupcarddivhidden">
        <HiddenSaveBackupCardDiv id="backupcard">
            <BackupCardTitleComponent><BackupCardImageComponent id="backupcardhead" src="https://nfttopshot-template.onrender.com/template-images/logo.png"/>{t('NFTバックアップカード')}</BackupCardTitleComponent>
            <QRcodeComponent id="qrcode"/>
            {props.qrTagStatus}
            {/* <BackupcardAddressText id="backupcardaddress">{`address:${localStorage.getItem('walletAddressFromPK').substring(0,20)}...`}</BackupcardAddressText> */}
            <BackupcardAddressText id="backupcardaddress">{backupCardAddressStatus}</BackupcardAddressText>
            <BackupcardMessageText id="backupcardmessage">
              ・{t('ブラウザに保存されたNFTを復元する際に使用します')}<br/>
              ・{t('誰とも共有しないで下さい')}<br/>
              ・{t('無くさないでください')}<br/>
              ・{t('復元する場合は、QRコードを読み込んでください')}<br/>
            </BackupcardMessageText>
        </HiddenSaveBackupCardDiv>
    </HiddenSaveBackupCardButtonDiv>
  );
};